export const buildScenarioSavePayload = (
  target,
  {photoFile, fileList, productIds} = {},
) => {
  const payload = {
    name: target?.name,
    mask: target?.mask,
    badge: target?.badge,
    due_date: target?.due_date,
    start_date: target?.start_date,
    finish_date: target?.finish_date,
    purpose: target?.purpose,
    objectives: target?.objectives,
    key_messages: target?.key_messages,
    keywords: target?.keywords,
    structure: target?.structure,
    script: target?.script,
    phase: target?.phase,
    questions: target?.questions,
    evaluation_template_id: target?.evaluation_template_id,
    certification: target?.certification,
  };

  if (photoFile) {
    payload.cover = photoFile;
  }

  if (fileList?.length) {
    payload.document_files = fileList;
  }

  if (productIds?.length) {
    payload.product_ids = productIds;
  } else if (target?.product_ids?.length) {
    payload.product_ids = target.product_ids;
  }

  if (target?.doctor_profile_id) {
    payload.doctor_profile_id = target.doctor_profile_id;
  }

  return payload;
};
